export default __webpack_public_path__ + "static/media/4.ae86ca6f.jpg";